'use client';
import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

import {Button, Heading, Text} from '@stubhub/bamboo';

import {IMAGES} from './constants';

import '../styles/index.scss';

const ErrorPanelView = ({
  className,
  header,
  subheader,
  paragraph,
  buttonText,
  clickHandler,
  secondaryButtonText,
  secondaryClickHandler,
  image = IMAGES.DEFAULT,
}) => (
  <section className={cs('ErrorPanel__container', className)}>
    <div className="ErrorPanel__wrapper">
      <div className={`ErrorPanel__image ErrorPanel__image--${image}`} />
      {header && (
        <Heading tag="h3" data-testid="errorHeader">
          {header}
        </Heading>
      )}
      {subheader && (
        <Heading tag="h4" data-testid="errorSubheader">
          {subheader}
        </Heading>
      )}
      {paragraph && <Text data-testid="errorParagraph">{paragraph}</Text>}
      <div className="ErrorPanel__buttons">
        {buttonText && <Button onClick={clickHandler}>{buttonText}</Button>}
        {secondaryButtonText && (
          <Button onClick={secondaryClickHandler} appearance="secondary">
            {secondaryButtonText}
          </Button>
        )}
      </div>
    </div>
  </section>
);

export default ErrorPanelView;

ErrorPanelView.propTypes = {
  /** Additional class names to apply to the container */
  className: PropTypes.string,

  /**  Text for the button*/
  buttonText: PropTypes.node,

  /** Text for the secondary button */
  secondaryButtonText: PropTypes.node,

  /** Header text */
  header: PropTypes.node,

  /** Subheader text */
  subheader: PropTypes.node,

  /** Paragraph text */
  paragraph: PropTypes.node,

  /** The error image */
  image: PropTypes.oneOf(Object.values(IMAGES)),

  /** Function to call when the button is clicked */
  clickHandler: PropTypes.func,

  /** Function to call when the secondary button is clicked */
  secondaryClickHandler: PropTypes.func,
};

export {IMAGES};
